import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
    };

    return axios.get(`${url}/activityWorkplaces?include=activity,workplace`, options)
        .then(response => {
            // console.log(response);
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get (id) {
    // console.log(id);
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/activityWorkplaces/${id}`, options)
        .then(response => {
            let activityWorkplace = jsona.deserialize(response.data);
            delete activityWorkplace.links;
            return activityWorkplace;
        });
}


function show (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/activityWorkplaces/${id}`, options)
        .then(response => {
            let activityWorkplace = jsona.deserialize(response.data);
            delete activityWorkplace.links;
            return activityWorkplace;
        });
}

function add (activityWorkplace) {
    const payload = jsona.serialize({
        stuff: activityWorkplace,
        includeNames: ['workplace','activity']
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/activityWorkplaces`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update (activityWorkplace) {
    const payload = jsona.serialize({
        stuff: activityWorkplace,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };
    return axios.patch(`${url}/activityWorkplaces/${activityWorkplace.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/activityWorkplaces/${id}`, options);
}

export default {
    list,
    get,
    show,
    add,
    update,
    destroy
};

